import React, { useState } from "react";
import { SchemaWorkflow } from "../components/SchemaWorkflow";
import { ValidationScreen } from "../components/ValidationScreen";
import { ConfirmationScreen } from "../components/ConfirmationScreen";
import {uploadHouseData} from "app/services/student-management/bulkUpload.service";
import { useMutation } from "react-query";
import { useSelector } from "react-redux";
import { selectActiveSession } from "app/modules/schools/selectors";
import { toast } from "react-toastify";

const schema = {
  id: "house",
  name: "House Information",
  description: "Update house name, color, and role assignments",
  columns: [
    { name: "Admission Number", type: "text", required: false },
    { name: "Registration Number", type: "text", required: false },
    { name: "SR Number", type: "text", required: false },
    { name: "House Name", type: "text", required: true },
    { name: "House Color", type: "text", required: false },
    { name: "Role", type: "text", required: false },
  ],
  // At least one of these identifier fields is required
  identifierFields: ["Admission Number", "Registration Number", "SR Number"],
};

export default function HouseInfo({ onBack }) {
  const [currentStep, setCurrentStep] = useState("upload");
  const [uploadedData, setUploadedData] = useState([]);
  const [validationResults, setValidationResults] = useState(null);
  const [updateResults, setUpdateResults] = useState(null);

  const selectedSession = useSelector(selectActiveSession);



  const {mutate: uploadHouseDataMutate, isLoading: isUploading}= useMutation(uploadHouseData, {
    onSuccess: (response) => {
      console.log("House data uploaded successfully:", response.data);
      setUpdateResults(response.data);
      setCurrentStep("confirmation");
    },
    onError: (error) => {
        toast.error(error?.response?.data?.message ||"Failed to upload house data.");
    },
  });

  const handleFileValidated = (data, results) => {
    setUploadedData(data);
    setValidationResults(results);
    setCurrentStep("validation");
  };

  const handleProceed = () => {
    console.log("Uploading house data...", uploadedData);
    let payload={
      houseData: uploadedData,
      session: selectedSession
    }
    uploadHouseDataMutate(payload);
  };

  const handleBackToUpload = () => {
    setCurrentStep("upload");
    setValidationResults(null);
  };

  const handleBackToDashboard = () => {
    onBack();
  };

  if (currentStep === "upload") {
    return (
      <SchemaWorkflow
        schema={schema}
        onBack={handleBackToDashboard}
        onFileValidated={handleFileValidated}
      />
    );
  }

  if (currentStep === "validation" && validationResults) {
    return (
      <ValidationScreen
        schema={schema}
        data={uploadedData}
        validationResults={validationResults}
        onReupload={handleBackToUpload}
        onProceed={handleProceed}
      />
    );
  }

  if (currentStep === "confirmation" && updateResults) {
    return (
      <ConfirmationScreen
        results={updateResults}
        onBackToDashboard={handleBackToDashboard}
      />
    );
  }

  return null;
}
